module.exports = __webpack_public_path__ + "img/ZZT--.98cec97e.png";